export var ProductLineComparisonType;
(function (ProductLineComparisonType) {
    ProductLineComparisonType["NORMAL"] = "normal";
    ProductLineComparisonType["EXTENDED"] = "extended";
})(ProductLineComparisonType || (ProductLineComparisonType = {}));
//# sourceMappingURL=ProductLineComparison.types.js.map